import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";

const PrivacyPolicy = () => {
  return (
    <>
      <Meta title={"Privacy Policy"} />
      <BreadCrumb title="Privacy Policy" />
      <Container class1="policy-wrapper  home-wrapper-2">
        <div className="row">
          <div className="col-12">
          <div className="policy px-5">
            <h1>User Data Policy</h1>
            <p>This User Data Policy applies to The Best Sellers Shop and its subsidiaries, referred to as "we," "our," and "us" in this Policy. By using our website ("www.thebestsellersshop.com"), you agree to the terms outlined in this User Data Policy. This policy covers the collection and use of personal information that you provide through your interactions with our website, in compliance with the Electronic Communications and Transactions Act and the Protection of Personal Information Act.</p>
            <p>At The Best Sellers Shop, we are dedicated to safeguarding your privacy and ensuring that any personal information collected is handled correctly, legally, and transparently, in accordance with the Protection of Personal Information Act.</p>
            <p>We reserve the right to change or update this User Data Policy at our discretion. This policy is in addition to any other terms and conditions that apply to our website. We are not responsible for the content or privacy practices of third-party websites linked from our site.</p>
            <p>We understand the importance of protecting your privacy and are committed to handling personal information that identifies you in a secure and respectful manner.</p>
         
            <b>Personal Information</b>
          <p>
          Personal Information

           Personal information about visitors to our site is collected only when knowingly and voluntarily submitted.  For example, we may need to collect such information to provide you with further services or to answer or forward any requests or enquiries. It is our intention that this policy will protect your personal information from being dealt with in any way that is inconsistent with applicable privacy laws in Kenya. 
          </p>
          <div>
            <b>Use of Information</b>
            <p>Personal information is collected solely for the purposes stated and agreed upon by the data subjects. Additionally, information may be retained when necessary for legal or research purposes, including:</p>
            <ul>
              <li>- To collect contact details for customer service;</li>
              <li>- To verify customer identity for security reasons;</li>
              <li>- To detect and prevent fraud, crime, money laundering, or other misconduct;</li>
              <li>- To conduct market research or customer satisfaction surveys, or for statistical analysis;</li>
              <li>- For audit and record-keeping as required by law;</li>
              <li>- For legal and warranty-related matters;</li>
              <li>- For marketing purposes, where consent has been provided.</li>
            </ul>
            <div>
              <b>Collecting information on Registered members</b>
              <p>As part of registering with us, we collect personal information about you in order for you to take full advantage of our services. To do this it may be necessary for you to provide additional information to us as detailed below.</p>
            </div>
            <div>
              <b>Registration</b>
              <p>Registration is completely optional. Registration may include submitting your name, email address, address, telephone numbers, option on receiving updates and promotional material and other information. You may access this information at any time by logging in and going to your account to view or amend the personal information held by us.</p>
            </div>
            <div>
              <b>Disclosure</b>
              <p>Personal information may be disclosed to service providers involved in the delivery of products or services to customers. We have agreements in place to ensure that they comply with the privacy requirements as required by the Protection of Personal Information Act. We may also disclose personal information:
                <ul>
                  <li>
                 - Where there exists a duty or a right to disclose in terms of law or industry codes;
                  </li>
                  <li>
                  - Where it is necessary to protect our rights.

                  </li>
                </ul>

              </p>
            </div>

            <div>

            <b>Information Security</b>

              <p>We have a legal obligation to protect personal information and prevent unauthorized access and use. Ensuring the security of personal data is a top priority, and we continuously review our security measures and processes to safeguard this information.</p>

              <p>Our Data Security policies and procedures encompass:</p>

              <ul>
                <li>- Physical server and data security;</li>
                <li>- Computer and network security;</li>
                <li>- Employee access to personal information;</li>
                <li>- Secure communications;</li>
                <li>- Security in contracting out activities or functions, e.g., delivery;</li>
                <li>- Retention and disposal of information;</li>
                <li>- Acceptable usage of personal information;</li>
                <li>- Governance and regulatory issues;</li>
                <li>- Monitoring access and usage of private information;</li>
                <li>- Investigating and reacting to security incidents.</li>
              </ul>

              <p>Additionally, our employees and contractors who work with our information systems are required to maintain the confidentiality of any personal information they handle. However, we are not liable for incidents resulting from unauthorized access to your personal data.</p>

            </div>

            <div>
            <b>Direct Marketing</b>

            <p>To opt out of receiving marketing emails and newsletters, simply unsubscribe. For SMS-related content, reply with the word "STOP" to discontinue receiving messages.</p>

            <b>How to Contact Us</b>

            <p>If you have any questions about this notice, need further information about our privacy practices, wish to withdraw consent, adjust preferences, or access and correct your personal information, please contact us at the following email address: thebestsellersshop@gmail.com</p>

            </div>
 
          </div>
          </div>

          </div>
        </div>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
